import { useParams } from '@remix-run/react';
import { useAtomValue } from 'jotai';
import { FC, useMemo } from 'react';
import { $RootTraffic, $Locale } from '@lemon8/web-app-shared/atom';
import { $PoiPost } from 'shared/atoms';
import { useSEOLinkBuilder } from '~/utils/build-seo-url';
import { LegacyArticleUtil } from 'shared/models';
import { DynamicHead } from '@lemon8/web-app-shared/ssr';
import { loadable } from 'jotai/utils';

export const ItemListJsonLD: FC<{
  urlList: string[];
  isCollectionPage?: boolean;
  mainUrl?: string;
}> = (props) => {
  const { urlList = [], isCollectionPage = false, mainUrl = '' } = props;
  const itemList = urlList.map((url: string, index: number) => {
    return {
      '@type': 'ListItem',
      position: index + 1,
      url,
    };
  });
  const baseItemListJSONLD = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: itemList,
  };
  const itemListJSONLD = isCollectionPage
    ? {
        ...baseItemListJSONLD,
        mainEntityOfPage: {
          '@id': mainUrl,
          '@type': 'CollectionPage',
        },
        numberOfItems: itemList.length || 0,
      }
    : baseItemListJSONLD;
  return (
    <DynamicHead>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(itemListJSONLD) }} />
    </DynamicHead>
  );
};

export const JsonLD: FC = () => {
  const buildSEOLink = useSEOLinkBuilder();
  const { enterHref } = useAtomValue($RootTraffic);
  const { region } = useAtomValue($Locale);
  const { poi_id: poiId = '' } = useParams();

  const loadablePoiPosts = useAtomValue(loadable($PoiPost(poiId)));

  if (loadablePoiPosts.state !== 'hasData' || !loadablePoiPosts.data) {
    return null;
  }

  const { items: poiPostItems = [] } = loadablePoiPosts.data;

  const collectionPageList = useMemo<string[]>(() => {
    const res: string[] = [];
    poiPostItems.forEach((a) => res.push(buildSEOLink(LegacyArticleUtil.getArticlePath(a))));
    return res;
  }, [poiPostItems, region]);

  return <ItemListJsonLD urlList={collectionPageList} isCollectionPage mainUrl={enterHref} />;
};
